"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActualInitOrMockedInit = void 0;
var getActualInitOrMockedInit = function (actualInit, mockedInit) {
    return function (config, successCallback, errorCallback) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var isMockMode = config.mock === true;
        if (!isMockMode) {
            return actualInit(config, successCallback, errorCallback);
        }
        return mockedInit(config, successCallback, errorCallback);
    };
};
exports.getActualInitOrMockedInit = getActualInitOrMockedInit;
